import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Button, Input, Space, Row, Col, Card, Tag, Select, Checkbox } from 'antd';
import { SaveOutlined } from "@ant-design/icons";
import { isMobile } from 'react-device-detect';
import BaseSelect from '@/components/Elements/BaseSelect';
import FamilyRelationships from './FamilyRelationships';
import InputMask from "react-input-mask";
import moment from 'moment';
import { updateCustomer } from '@/redux/actions/customerActions';
import { _newLine, buildPhonesPayload, customerGender, formatDateForInputMask, mergePhonesWithConfirmations } from '@/utils/helpers';
import { getListProvinces, getListWards } from '@/redux/actions/RegionsActions';
import PhoneDuplicateRelationModal from './PhoneDuplicateRelationModal';
import _ from 'lodash';
import BaseRadioList from '@/components/Elements/BaseRadios';

class CustomerEditForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            wards: [],
            customer_family: [],
            currentCustomerFamily: [],

            phoneDuplicateModalVisible: false,
            phoneDuplicateData: {},
            pendingValues: null
        };
    }
    componentDidMount() {
        const { currentItem } = this.props;
        this.props.getListProvinces();

        // Lấy dữ liệu từ currentItem nếu có sẵn
        if (currentItem) {
            this.updateStateFromCurrentItem(currentItem, {}); // Truyền {} làm prevCurrentItem để đảm bảo so sánh luôn khác
        }
    }

    componentDidUpdate(prevProps) {
        const { currentItem } = this.props;

        if (prevProps.currentItem !== currentItem) {
            this.updateStateFromCurrentItem(currentItem, prevProps.currentItem);
        }
    }

    updateStateFromCurrentItem = (currentItem, prevCurrentItem) => {
        if (!currentItem) return;

        const updates = {};

        if (currentItem.family_relationships) {
            updates.currentCustomerFamily = currentItem.family_relationships;
            updates.customer_family = currentItem.family_relationships; //
        }

        this.setState(updates);

        // Gọi API lấy danh sách phường/xã nếu district_code thay đổi
        if (
            currentItem?.province_code &&
            currentItem.province_code !== prevCurrentItem?.province_code
        ) {
            this.props.getListWards({ province_code: currentItem.province_code }).then((res2) => {
                this.setState({ wards: res2.data });
            });
        }
    }

    async submit(e) {
        e.preventDefault();

        const { form } = this.props;
        const noPhone = form.getFieldValue('no_phone');

        // ÉP touched + validate other_contact khi submit
        if (noPhone) {
            form.setFields({
                other_contact: {
                    value: form.getFieldValue('other_contact'),
                    touched: true
                }
            });

            form.validateFields(['other_contact'], { force: true });
        }

        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });

                try {
                    if (this.props.currentItem) {
                        const { customer_family } = this.state;

                        const phonesRaw = values.phones || [];

                        // STEP 1: SOFT
                        const phonesSoft = buildPhonesPayload(phonesRaw);

                        const softPayload = {
                            ...values,
                            phones: phonesSoft,
                            mode: 'soft',
                            customer_family: customer_family
                        };

                        console.log('SUBMIT PAYLOAD (SOFT):', softPayload);

                        await this.props.updateCustomer(this.props.currentItem.id, softPayload);
                        this.onClose();
                    }
                } catch (error) {
                    const res = error?.response?.data;

                    // BACKEND SOFT DUPLICATE
                    if (res?.data?.type === 'PHONE_DUPLICATE_SOFT') {
                        this.setState({
                            phoneDuplicateModalVisible: true,
                            phoneDuplicateData: res.data.phones,
                            pendingValues: values,
                            isLoading: false,
                        });

                        return;
                    }

                    this.setState({ isLoading: false });
                }
            }
        });
    }

    handleSubmitHard = async (phonesConfirmedFromModal, customerFamily) => {
        try {
            this.setState({ isLoading: true });

            const { pendingValues, customer_family } = this.state;

            // 1. Lấy danh sách phone gốc user nhập
            const rawPhones = pendingValues.phones || [];

            // 2. MERGE phone gốc + xác nhận từ modal
            const phonesHard = mergePhonesWithConfirmations(
                rawPhones,
                phonesConfirmedFromModal
            );

            // 3. Merge family (giữ logic hiện tại của bạn – ĐÚNG)
            const mergedCustomerFamily = _.uniqBy(
                [...customer_family, ...customerFamily],
                'related_id'
            );

            const hardPayload = {
                ...pendingValues,
                phones: phonesHard,
                mode: 'hard',
                customer_family: mergedCustomerFamily,
            };

            console.log('SUBMIT PAYLOAD (HARD):', hardPayload);

            await this.props.updateCustomer(this.props.currentItem.id, hardPayload);

            this.setState({
                phoneDuplicateModalVisible: false,
                phoneDuplicateData: {},
                pendingValues: null,
                isLoading: false,
            });

            this.onClose();
        } catch (error) {
            this.setState({ isLoading: false });
        }
    };

    handleClosePhoneDuplicateModal = () => {
        this.setState({
            phoneDuplicateModalVisible: false,
            phoneDuplicateData: {},
            pendingValues: null,
        });
    };

    onClose() {
        this.props.reloadData();
        this.props.onCancel();
        this.props.form.resetFields();
        this.setState({ isLoading: false });
    }

    loadWards(province_code) {
        if (province_code) {
            this.props.getListWards({ province_code: province_code }).then(res => {
                this.props.form.setFieldsValue({ wards_code: null });
                this.setState({ wards: res.data })
            })
        }
    }

    getItems = data => {
        this.setState({ customer_family: data })
    }

    handleBirthdayChange = (e) => {
        const value = e.target.value;
        const date = moment(value, "DD/MM/YYYY", true);

        if (date.isValid()) {
            const age = moment().diff(date, "years");
            this.props.form.setFieldsValue({ age });
        } else {
            this.props.form.setFieldsValue({ age: "" });
        }
    };

    render() {
        var {
            wards,
            isLoading,
            currentCustomerFamily,
        } = this.state;
        var {
            visible,
            currentItem,
            list_provinces,
            filterData
        } = this.props;

        const customerStatusActiveList = filterData.statuses;
        const customer_source_active_list = filterData.sources;
        const branchActiveList = filterData.branches;
        const customerInteractiveTypeActiveList = filterData.interactive_types;
        const customerInteractiveStatusActiveList = filterData.interactive_statuses;

        const { getFieldError, isFieldTouched, getFieldValue, getFieldDecorator } = this.props.form;

        const noPhone = getFieldValue('no_phone');

        const phoneErrors = getFieldError('phones');
        const phoneTouched = isFieldTouched('phones');
        const showPhoneError = !noPhone && phoneTouched && phoneErrors && phoneErrors.length;

        const otherErrors = getFieldError('other_contact');
        const otherTouched = isFieldTouched('other_contact');
        const showOtherError = noPhone && otherTouched && otherErrors && otherErrors.length;

        return (
            <>
                <Drawer
                    visible={visible}
                    title={`${currentItem ? currentItem?.full_name : ""} - ${currentItem?.code}`}
                    onOk={(e) => this.submit(e)}
                    onClose={() => this.onClose()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '70%'}
                    footer={
                        <div style={{ textAlign: 'right', }}>
                            <Space>
                                <Button key="back" size='large' onClick={() => this.onClose()}>
                                    Huỷ
                                </Button>
                                <Button
                                    loading={isLoading}
                                    key="submit"
                                    type="primary"
                                    onClick={(e) => this.submit(e)}
                                    size='large'
                                    icon={<SaveOutlined />}
                                >
                                    Cập nhật
                                </Button>
                            </Space>
                        </div>
                    }
                >
                    {visible ?
                        <Form layout='vertical'>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Row gutter={16}>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Tên khách hàng">
                                                {getFieldDecorator('full_name', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng điền',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.full_name : null
                                                })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Nickname">
                                                {getFieldDecorator('fb_name', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng điền',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.fb_name : null
                                                })(<Input disabled={currentItem.mode == 'from_message' ? true : false} />)}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Cơ sở">
                                                {getFieldDecorator('branch_id', {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: 'Vui lòng chọn',
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.branch_id : null,
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <BaseSelect
                                                        options={branchActiveList || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        defaultText="Chọn cơ sở"
                                                        placeholder="Chọn cơ sở"
                                                        className="w-100"
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>

                                        <Col xs={24} md={16}>
                                            <Form.Item
                                                label="Số điện thoại"
                                                validateStatus={showPhoneError ? 'error' : null}
                                                help={showPhoneError ? phoneErrors[0] : null}
                                            >
                                                {getFieldDecorator("phones", {
                                                    initialValue: currentItem?.phone_numbers || [],
                                                    rules: noPhone
                                                        ? []
                                                        : [
                                                            {
                                                                required: true,
                                                                message: "Vui lòng nhập số điện thoại hoặc tích 'Khách không cung cấp SĐT'",
                                                            },
                                                        ],
                                                })(
                                                    <Select
                                                        mode="tags"
                                                        style={{ width: '100%' }}
                                                        placeholder="Nhập SĐT, cách nhau bằng dấu phẩy"
                                                        tokenSeparators={[',']}
                                                        open={false}
                                                        disabled={noPhone}
                                                    />
                                                )}
                                            </Form.Item>
                                            <Form.Item style={{ marginTop: -8 }}>
                                                {getFieldDecorator('no_phone', {
                                                    valuePropName: 'checked',
                                                    initialValue: !!currentItem?.no_phone,
                                                })(
                                                    <Checkbox
                                                        onChange={e => {
                                                            const checked = e.target.checked;

                                                            if (checked) {
                                                                // Tick: clear phones
                                                                this.props.form.setFields({
                                                                    phones: { value: [], errors: [] },
                                                                });

                                                                // (optional) đánh dấu other_contact để user nhập
                                                                // this.props.form.validateFields(['other_contact'], { force: true });
                                                            } else {
                                                                // Bỏ tick: clear other_contact
                                                                this.props.form.setFields({
                                                                    other_contact: { value: null, errors: [] },
                                                                });

                                                                // QUAN TRỌNG: ép phones bị "touched" để show lỗi ngay
                                                                this.props.form.setFields({
                                                                    phones: { value: this.props.form.getFieldValue('phones') || [], touched: true },
                                                                });

                                                                // ép validate lại phones theo rule required mới
                                                                this.props.form.validateFields(['phones'], { force: true });
                                                            }

                                                            this.forceUpdate();
                                                        }}
                                                    >
                                                        Khách không cung cấp số điện thoại
                                                    </Checkbox>
                                                )}
                                            </Form.Item>
                                            {noPhone && (
                                                <Form.Item
                                                    label="Phương thức liên hệ khác"
                                                    validateStatus={showOtherError ? 'error' : null}
                                                    help={showOtherError ? otherErrors[0] : null}
                                                >
                                                    {getFieldDecorator("other_contact", {
                                                        initialValue: currentItem?.other_contact || null,
                                                        rules: noPhone
                                                            ? [
                                                                {
                                                                    required: true,
                                                                    message: "Vui lòng nhập phương thức liên hệ khác (Facebook, Zalo, Email...)",
                                                                },
                                                            ]
                                                            : [],
                                                    })(
                                                        <Input placeholder="Ví dụ: Zalo, Facebook, Email..." />
                                                    )}
                                                </Form.Item>
                                            )}
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Giới tính">
                                                {getFieldDecorator("gender", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: "Vui lòng chọn",
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.gender : null,
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <BaseRadioList
                                                        options={customerGender || []}
                                                        placeholder="Chọn một bản ghi"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Nguồn">
                                                {getFieldDecorator("customer_source_id", {
                                                    rules: [
                                                        {
                                                            required: true,
                                                            message: "Vui lòng chọn",
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.customer_source_id : null,
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <BaseSelect
                                                        options={customer_source_active_list || []}
                                                        optionValue="id"
                                                        optionLabel="name"
                                                        showSearch
                                                        placeholder="Chọn một bản ghi"
                                                        style={{ width: '100%' }}
                                                    />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Năm sinh">
                                                {getFieldDecorator('birthday', {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: 'Vui lòng điền',
                                                        },
                                                    ],
                                                    initialValue: currentItem?.birthday ? formatDateForInputMask(currentItem.birthday, false) : '',
                                                    normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                                })(
                                                    <InputMask
                                                        mask="99/99/9999"
                                                        placeholder="dd/mm/yyyy"
                                                        onChange={e => {
                                                            this.handleBirthdayChange(e);
                                                        }}
                                                    >
                                                        {(inputProps) => <Input {...inputProps} />}
                                                    </InputMask>
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Tuổi">
                                                {getFieldDecorator("age", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng điền",
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.age : null
                                                })(
                                                    <Input />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Mã số thẻ mới">
                                                {getFieldDecorator("card_number_new", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng điền",
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.card_number_new : null
                                                })(
                                                    <Input />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} md={8}>
                                            <Form.Item label="Mã số sổ khám">
                                                {getFieldDecorator("medical_book_number", {
                                                    rules: [
                                                        {
                                                            required: false,
                                                            message: "Vui lòng điền",
                                                        },
                                                    ],
                                                    initialValue: currentItem ? currentItem.medical_book_number : null
                                                })(
                                                    <Input />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Ghi chú">
                                        {getFieldDecorator('note', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền",
                                                },
                                            ],
                                            initialValue: currentItem ? _newLine(currentItem.note) : null
                                        })(
                                            <Input.TextArea rows={4} />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={8}>
                                    <Form.Item label='Trạng thái'>
                                        {getFieldDecorator("customer_status_id", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.customer_status_id : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={customerStatusActiveList || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label='Loại tương tác'>
                                        {getFieldDecorator("interaction_type_id", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.interaction_type_id : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={customerInteractiveTypeActiveList || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label='Trạng thái tương tác'>
                                        {getFieldDecorator("interaction_status_id", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.interaction_status_id : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={customerInteractiveStatusActiveList || []}
                                                optionValue="id"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24} md={8}>
                                    <Form.Item label="Link facebook">
                                        {getFieldDecorator("fb_link", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền!",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.fb_link : null
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Link fanpage">
                                        {getFieldDecorator("fb_source", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.fb_source : null
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Tỉnh/Thành phố">
                                        {getFieldDecorator("province_code", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.province_code : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={list_provinces || []}
                                                optionValue="code"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                                onChange={(code) => this.loadWards(code)}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Phường/Xa">
                                        {getFieldDecorator("wards_code", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.wards_code : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <BaseSelect
                                                options={wards || []}
                                                optionValue="code"
                                                optionLabel="name"
                                                showSearch
                                                placeholder="Chọn một bản ghi"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={8}>
                                    <Form.Item label="Thôn, phố">
                                        {getFieldDecorator("hamlet", {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng chọn",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.hamlet : null,
                                            normalize: value => value !== undefined ? value : null // Trường hợp value = undefined thì tên field vẫn được truyền lên server
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Địa chỉ">
                                        {getFieldDecorator('address', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền!",
                                                },
                                            ],
                                            initialValue: currentItem ? currentItem.address : null
                                        })(
                                            <Input />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row gutter={16} className='mb-5'>
                                <Col xs={24} md={24}>
                                    <FamilyRelationships currentData={currentCustomerFamily} getItems={(data) => this.getItems(data)} />
                                </Col>
                            </Row>
                        </Form>
                        : null}
                </Drawer>

                <PhoneDuplicateRelationModal
                    visible={this.state.phoneDuplicateModalVisible}
                    duplicateData={this.state.phoneDuplicateData}
                    loading={isLoading}
                    onCancel={this.handleClosePhoneDuplicateModal}
                    onConfirm={({ phonesConfirmedFromModal, customerFamily }) => {
                        this.handleSubmitHard(phonesConfirmedFromModal, customerFamily);
                    }}
                />

            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        list_provinces: state.RegionsReducer.list_provinces,
        filterData: state.filterReducer.list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateCustomer: (id, data) => dispatch(updateCustomer(id, data)),
        getListProvinces: () => dispatch(getListProvinces()),
        getListWards: (filter) => dispatch(getListWards(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'CustomerEditForm' })(CustomerEditForm));
